import React           from 'react';
import PropTypes       from 'prop-types';
import {
  branch,
  compose,
  renderComponent,
}                      from 'recompose';
import mapCurrentUser, {
  MAP_CURRENT_USER_PROP_CURRENT_USER,
  MAP_CURRENT_USER_PROP_IS_LOADING_USER,
  MAP_CURRENT_USER_PROP_IS_LOGGED_IN,
  MAP_CURRENT_USER_PROP_LOAD_USER_ERROR,
  MAP_CURRENT_USER_PROP_USER_CAPABILITIES
}                      from '../../auth/mapCurrentUser';
import Loading         from '../../generic/Loading';
import { filterProps } from '../../HOC/filterProps';


export const LoggedInUserPreLoader = compose(
  mapCurrentUser(),
  branch(
    ({
       [MAP_CURRENT_USER_PROP_IS_LOGGED_IN]:      isLoggedIn,
       [MAP_CURRENT_USER_PROP_IS_LOADING_USER]:   isLoading,
       [MAP_CURRENT_USER_PROP_LOAD_USER_ERROR]:   error,
       [MAP_CURRENT_USER_PROP_CURRENT_USER]:      currentUser,
       [MAP_CURRENT_USER_PROP_USER_CAPABILITIES]: userCapabilities,
     }) => isLoggedIn && (!currentUser || !userCapabilities) && !error,
    renderComponent(() => <Loading/>),
  ),
  filterProps({whitelist: ['children']}),
)(({children}) => children);


LoggedInUserPreLoader.propTyes = {
  children: PropTypes.element.isRequired,
};


// WEBPACK FOOTER //
// ./src/components/resources/User/LoggedInUserPreLoader.js